// Customer roles
export const ADMIN_ROLE = 'admin';
export const BRANCH_HEAD_ROLE = 'branch_Head';
export const BUSINESS_EXECUTIVE_ROLE = 'business_Executive';
export const CLERK_ROLE = 'clerk';
export const CONTROLLER_ROLE = 'controller';
export const DISPATCHER_ROLE = 'dispatcher';
export const FINANCIAL_ACCOUNTANT_ROLE = 'financial_accountant';
export const PAYROLL_CLERK_ROLE = 'payroll_Clerk';
export const RECRUITER_ROLE = 'recruiter';
export const SALES_REPRESENTATIVE_ROLE = 'sales_representative';
export const PDL_CLERK_WITH_BACKOFFICE_TASKS_ROLE = 'pdl_clerk_backoffice';
export const PAYROLL_CLERK_WITH_BACKOFFICE_TASKS_ROLE = 'payroll_clerk_backoffice';

export const CUSTOMER_BASE_ACCESS_ROLE_GROUP = [
  ADMIN_ROLE,
  BRANCH_HEAD_ROLE,
  BUSINESS_EXECUTIVE_ROLE,
  CLERK_ROLE,
  CONTROLLER_ROLE,
  DISPATCHER_ROLE,
  FINANCIAL_ACCOUNTANT_ROLE,
  PAYROLL_CLERK_ROLE,
  RECRUITER_ROLE,
  SALES_REPRESENTATIVE_ROLE,
  PDL_CLERK_WITH_BACKOFFICE_TASKS_ROLE,
  PAYROLL_CLERK_WITH_BACKOFFICE_TASKS_ROLE,
];

export const BORROWER_ROLE = 'borrower';
export const EXTERNAL_EMPLOYEE_ROLE = 'external_employee';

export const CUSTOMER_ROLES = [...CUSTOMER_BASE_ACCESS_ROLE_GROUP, BORROWER_ROLE, EXTERNAL_EMPLOYEE_ROLE];

// Zvoove roles
export const ZVOOVE_SYSTEM_OPERATOR_ROLE = 'internal_admin';
export const ZVOOVE_SUPER_ADMIN_ROLE = 'internal_operator';
export const ZVOOVE_CONTENT_MANAGER_ROLE = 'zvoove_content_manager';
export const ZVOOVE_CUSTOMER_SUCCESS_ROLE = 'zvoove_customer_success';
export const ZVOOVE_EMPLOYEE_ROLE = 'zvoove_employee';

// Partner roles
export const PAYROLL_MANAGER_ROLE = 'payroll_manager';
export const PARTNER_ROLE = 'external_partner';
export const PARTNER_ACCESS_ROLE = 'external_partner_access';
export const SERVICE_AGENT_ROLE = 'service_agent';
